import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';

import SMHeaderContext from '../../../SMHeaderContext';

export const MenuButton = ({ title, url, name }) => {
  const { excludeMenuItems } = useContext(SMHeaderContext);

  if (excludeMenuItems.includes(name)) return null;

  return (
    <Button
      variant="text"
      size="sm"
      className="sm-header__nav-cta--alt sm-header__text"
      href={url}
      key={title}
    >
      {title}
    </Button>
  );
};

MenuButton.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  title: PropTypes.any.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default MenuButton;
